/*
 * The line every settings tab opens with.
 *
 * Always rendered, even with nothing to say. Two reasons, and both are why this
 * is a component rather than a conditional paragraph per page: the tabs would
 * otherwise start at different heights depending on whether their page happens
 * to have a status to show, and a line that appears only on failure shoves the
 * rows down at the exact moment someone is looking at what they just clicked.
 *
 * Idle is a non-breaking space, not an empty string. An empty line box has no
 * height at all. Reserving the space with a height utility would be a bet on
 * which utilities this package generates; a character is not.
 *
 * Written as an escape: a bare U+00A0 is invisible in a diff and does not
 * survive being copied between files, which is exactly how this regressed once
 * already. A plain space would be collapsed.
 */
const IDLE = '\u00A0';

export interface StatusLineProps {
  /** Nothing to say leaves the space reserved and empty. */
  message?: string;
  tone?: 'muted' | 'danger';
}

export function StatusLine({ message, tone = 'muted' }: StatusLineProps) {
  return (
    <p
      role='status'
      aria-live='polite'
      className={`mb-4 text-sm ${tone === 'danger' ? 'text-danger' : 'text-ink-muted'}`}
    >
      {message ?? IDLE}
    </p>
  );
}
